module.exports = __webpack_public_path__ + "img/icon-requests.d698cbf1.svg";